module.exports = __webpack_public_path__ + "static/img/energy-h5-6.33b0f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/energy-h5-6.png
// module id = zAl+
// module chunks = 34